import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import {
  Button,
  ButtonProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { Icon } from "../Icon/Icon";

interface OpenDialogButtonProps extends ButtonProps {
  label: string;
  typographyProps?: TypographyProps & Record<`data-${string}`, string>;
}

const StyledEndIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.secondary[3],
}));

export const OpenDialogButton = (props: OpenDialogButtonProps) => {
  const { label, typographyProps = {}, ...rest } = props;

  return (
    <Button
      fullWidth
      endIcon={<StyledEndIcon icon={faAngleRight} />}
      color="secondary"
      size="large"
      variant="contained"
      {...rest}
    >
      <Typography noWrap color="secondary.1" {...typographyProps}>
        {label}
      </Typography>
    </Button>
  );
};
